import { APP_CONFIG } from './Config';

export const setBaseUrl = () => {
  return APP_CONFIG;
};
